// extracted by mini-css-extract-plugin
export default {"modalOverlay":"nC-z","modalContent":"oC-z","header":"pC-z","close":"qC-z"};